import { render, staticRenderFns } from "./PaymentSystemLogo.vue?vue&type=template&id=66853a36&scoped=true&"
import script from "./PaymentSystemLogo.vue?vue&type=script&lang=ts&"
export * from "./PaymentSystemLogo.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentSystemLogo.vue?vue&type=style&index=0&id=66853a36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66853a36",
  null
  
)

export default component.exports